export function scrollToDiv(divId, eventTarget) {
    let target = $(eventTarget);
    if (!target.hasClass("collapsed") || target.hasClass("list-group-item") || target.hasClass("no-arrow")) {
        $("html").animate({ scrollTop: $("#" + divId).offset().top - 90, }, "fast");
    }
}

export function scrollToTop() {
    $("html").animate({ scrollTop: 0, }, "fast");
}